module.exports = __webpack_public_path__ + "media/images/icons/outlined/windows-329ee8b71b0e1576a28cd145f097f12d.svg";